import React from "react";
import Highcharts from "highcharts";
import * as HighchartsMore from 'highcharts/highcharts-more';
import HighchartsReact from "highcharts-react-official";
import withTheme from "../../../hocs/withTheme";
import { getBubbleChartOptions } from "./constants";
import "./BubbleChart.css";

const initHighchartsMore = (HighchartsMore as any).default || HighchartsMore;
if (typeof initHighchartsMore === 'function') {
    initHighchartsMore(Highcharts);
}

interface BubbleChartProps {
    options: any;
}

function BubbleChart({ options }: BubbleChartProps) {
    return (
        <div className="Risk-return-container bubble-chart">
            <div className="Risk-return-chart-container">
                <HighchartsReact
                    highcharts={Highcharts}
                    containerProps={{
                        className: "Highcharts-risk-return",
                    }}
                    options={getBubbleChartOptions(options)}
                />
            </div>
        </div>
    );
}

export default withTheme(BubbleChart);